import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initGallerySlider = () => {
  const sliderEl = document.querySelector(".gallery__slider");
  if (!sliderEl) return;

  const frameEl = sliderEl.closest(".gallery__frame") ?? sliderEl;

  const slides = Array.from(sliderEl.querySelectorAll(".gallery__slide"));
  const total = slides.length;
  const prevEl = frameEl.querySelector(".gallery__btn--prev");
  const nextEl = frameEl.querySelector(".gallery__btn--next");
  const progressFillEl = sliderEl.querySelector(".gallery__progress-fill");
  const counterEl = sliderEl.querySelector(".gallery__counter");
  const images = slides.map((slide) => slide.querySelector(".gallery__image"));

  const revealImage = (image) => {
    if (!image) return;

    const media = image.closest(".gallery__media");
    const markReady = () => media?.classList.add("is-loaded");
    const decodeAndReveal = () => {
      if (typeof image.decode !== "function") {
        markReady();
        return;
      }

      image.decode().catch(() => {}).finally(markReady);
    };

    if (media?.classList.contains("is-loaded")) return;

    if (!image.complete) {
      if (image.dataset.galleryRevealBound === "true") return;

      image.dataset.galleryRevealBound = "true";
      image.addEventListener("load", decodeAndReveal, { once: true });
      image.addEventListener("error", () => {
        media?.classList.add("is-error");
        markReady();
      }, { once: true });
      return;
    }

    if (image.naturalWidth === 0) {
      media?.classList.add("is-error");
      markReady();
      return;
    }

    decodeAndReveal();
  };

  const preloadSlide = (index) => {
    const image = images[index];

    if (!image) return;

    image.loading = "eager";
    revealImage(image);
  };

  const preloadAround = (activeIndex) => {
    preloadSlide(activeIndex);
    preloadSlide(activeIndex + 1);
    preloadSlide(activeIndex + 2);
  };

  const updateProgress = (activeIndex = 0) => {
    const progress = total > 0 ? ((activeIndex + 1) / total) * 100 : 0;
    const current = String(activeIndex + 1).padStart(2, "0");

    progressFillEl?.style.setProperty("--gallery-progress", `${progress}%`);

    if (counterEl) {
      counterEl.textContent = `/${current}`;
    }
  };

  const swiper = new Swiper(sliderEl, {
    modules: [Keyboard, Mousewheel, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    on: {
      init(instance) {
        updateProgress(instance.realIndex);
        preloadAround(instance.activeIndex);
      },
      slideChange(instance) {
        updateProgress(instance.realIndex);
        preloadAround(instance.activeIndex);
      },
    },
  });

  images.forEach(revealImage);
  preloadAround(0);
  updateProgress(swiper.realIndex);
};

export default initGallerySlider;
